export default __webpack_public_path__ + "static/media/SMASH.afc16be7.png";